import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-greater', 'MathGreater', [["path",{"d":"M5 18l14 -6l-14 -6"}]]);